const mandatory = [
    {
        url: 'footer.impressum_url',
        name: 'footer.impressum'
    },
    {
        url: 'footer.privacy_url',
        name: 'footer.privacy'
    },
    {
        url: 'footer.comaplaints_url',
        name: 'footer.comaplaints'
    },
    {
        url: 'footer.aszf_url',
        name: 'footer.aszf'
    },
    {
        url: 'footer.travelPolicy_url',
        name: 'footer.travelPolicy'
    },
    {
        url: 'footer.gdpr_url',
        name: 'footer.gdpr'
    },
]

export default mandatory